import { createFileRoute } from "@tanstack/react-router"
import { projectFormsViewLayoutHandle } from "src/views/ProjectFormsView/constants"
import { ProjectFormsView } from "src/views/ProjectFormsView/ProjectFormsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/forms/")({
	component: ProjectFormsView,
	staticData: projectFormsViewLayoutHandle,
})
